import styled from '@emotion/styled';
import { Theme } from '@silvertours/front-shared';

const PrimaryTitle = styled.h1`
  margin: 0;
  font-family: ${({ theme }) => theme.fontFamily.alternate};
  font-weight: bold;
  font-size: 1.375rem;
  line-height: 1.25;
  text-align: center;
  color: ${({ theme }) => theme.color.text};

  ${Theme.mq('sm')} {
    text-align: left;
  }

  ${Theme.mq('lg')} {
    font-size: 1.75rem;
    line-height: 1.4285;
  }
`;

const SupplierList = styled.ul<{ isStandAlone: boolean }>`
  grid-column: ${({ isStandAlone }) => (isStandAlone ? 'span 2' : '')};
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-around;
  gap: 1rem;
  margin: 0 auto;
  padding: 0;

  ${Theme.mq('sm')} {
    margin-left: 0;
    margin-right: 0;
    justify-content: space-between;
  }

  ${Theme.mq('lg')} {
    padding-top: ${({ isStandAlone }) => (isStandAlone ? '0' : '0.5rem')};
    padding-bottom: ${({ isStandAlone }) => (isStandAlone ? '0' : '0.5rem')};
    align-items: end;
    justify-content: ${({ isStandAlone }) => (isStandAlone ? 'center' : 'end')};
    gap: ${({ isStandAlone }) => (isStandAlone ? '2.5rem' : '1.5rem')};
  }
`;

const SupplierListItem = styled.li`
  display: inline-flex;
  align-items: center;

  svg {
    width: auto;
    height: 1.5rem;
    vertical-align: bottom;
    filter: grayscale() opacity(0.7);
  }
`;

const SupplierWrapper = styled.div<{ includeSearch: boolean }>`
  display: grid;
  gap: 1rem;
  padding: 3rem 0 2rem;

  ${({ includeSearch }) =>
    includeSearch &&
    `${Theme.mq('lg')} {
    grid-template-columns: repeat(2, 0.5fr);
  }

  ${Theme.mq('xl')} {
    grid-template-columns: 0.4fr 0.6fr;
  }`}
`;

export { PrimaryTitle, SupplierList, SupplierListItem, SupplierWrapper };
